import styled from "styled-components";
import { Colors } from "./Colors";
import { Fonts } from "./Fonts";

export const mobileSize = {
  large: "only screen and (max-device-width: 812px)"
};

const formContainer = {
  textAlign: "center",
  width: "50%",
  margin: "auto"
};

const mainContainer = {
  paddingTop: 20,
  marginTop: "2.5%",
  paddingLeft: 75,
  paddingRight: 75
};

const container = {
  padding: "20px"
};

const padding = {
  small: 10,
  medium: 15,
  large: 30,
  xlarge: 40
};

const margin = {
  small: 10,
  medium: 15,
  large: 25
};

const image = {
  smallIcon: {
    height: 45,
    width: 45
  },
  icon: {
    height: 64,
    width: 64
  },
  largeIcon: {
    height: 100,
    width: 100
  }
};

const borders = {
  chatborder: "solid 2px #7aadff",
  primaryBorder: `solid 2px ${Colors.mainColor}`,
  secondaryBorder: "solid 2px lightgray"
};

export const MainContainerTheme = styled.div`
  padding: 20px;
  margin: auto;
  width: 75%;
  margin-top: 2.5%;
  @media ${mobileSize.large} {
    margin: 1.25%;
    padding: 5px;
    width: 100%; 
  }
`;

export const MainTitleTheme = styled.div`
  ... ${Fonts.headerFont};
`;

export const iconFontSize = 40;

// The size of icons
export const iconSize = {
  small: 20,
  medium: 30,
  large: 40
};

const borderRadius = {
  small: "5px",
  medium: "10px",
  large: "15px"
};

export const Metrics = {
  mainContainer,
  formContainer,
  container,
  padding,
  margin,
  image,
  borders,
  borderRadius,
  iconFontSize
};
